import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-thuiswerken',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconThuiswerken {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M19.02 29.29v.68H1.44c-.8-.04-1.44-.7-1.44-1.51 0-.65.41-1.21.99-1.42.02 0 5.03-2.01 5.03-2.01-1.48 0-3.01-1.48-3.01-3.02V6c0-1.65 1.34-3 3-3h20.98c1.66 0 3 1.34 3 3v12.72l-1.19-.87a2.97 2.97 0 0 0-.79-.41V6.03c0-.55-.44-.99-.99-.99H6.06c-.57 0-1.02.46-1.02 1.02v15.96c0 .55.44.99.99.99h12.19l-.96.7c-.65.47-1.07 1.17-1.19 1.96-.12.79.07 1.58.54 2.23l.12.16c.54.74 1.39 1.19 2.3 1.22Zm16.77-2.62-.17.22c-.34.44-.97.51-1.41.17l-1.19-.92v5.87c0 .55-.45 1-1 1h-9.99c-.55 0-1-.45-1-1v-5.87l-1.29.96a.996.996 0 0 1-1.4-.21l-.12-.16a.996.996 0 0 1 .22-1.4l8.01-5.86a.99.99 0 0 1 1.18 0l3.38 2.46v-.91c0-.55.45-.99 1-.99s1 .45 1 1v2.37l2.57 1.86c.46.33.55.98.2 1.42Zm-6.78.34c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1zM14.98 14.96a.996.996 0 0 0 0-1.41l-3.57-3.57h1.68c.55 0 1-.45 1-1s-.45-1-1-1H8.98c-.55 0-1 .45-1 1v4.11c0 .55.45 1 1 1s1-.45 1-1v-1.71l3.59 3.59c.39.39 1.02.39 1.41 0Z"/>
</svg>

    );
  }
}
